<script setup>
const { tagText } = defineProps({
  tagText: String,
});
</script>

<template>
  <div class="read-only-tag body-xs-size" automation-id="ReadOnlyTag">
    {{ tagText }}
  </div>
</template>

<style lang="less" scoped>
.read-only-tag {
  padding: 2px 8px;
  border: 1px solid @color-tags-outlined-default;
  border-radius: 6px;
  align-items: center;
  text-align: center;
  display: inline-flex;
  color: @color-blue-gray-dark;
  cursor: default;
  min-width: max-content;
}
</style>
